import { useEffect, useState } from 'react';

/**
 * Returns the current epoch ms, ticking at the given interval.
 * Pauses when the document is hidden and resumes on visibilitychange.
 */
export function useNow(intervalMs: number): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    let id: ReturnType<typeof setInterval> | null = null;

    function start() {
      setNow(Date.now());
      id = setInterval(() => setNow(Date.now()), intervalMs);
    }

    function stop() {
      if (id != null) {
        clearInterval(id);
        id = null;
      }
    }

    function handleVisibility() {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    }

    if (!document.hidden) {
      start();
    }

    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      stop();
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, [intervalMs]);

  return now;
}
